import { DashboardsErrorBoundary } from '@/views/dashboards/dashboards.error';

export default DashboardsErrorBoundary;
